import { createApp } from 'vue';
import InvestorRelationsBlock from './InvestorRelationsBlock.vue';

const blocks = document.querySelectorAll('[data-feature="investor-relations-block"]');

blocks.forEach((block) => {
	const app = createApp({
		name: 'InvestorRelationsBlockApp',
	});

	app.component('investor-relations-block', InvestorRelationsBlock);
	app.mount(block);
});
